import Gantt from './Gantt.vue';
import { withInstall } from './utils/withInstall';

export * from './types';

export const VueGantt3 = withInstall(Gantt);
export default VueGantt3;